/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-c445dc73.js';
import { useRef } from 'react';
import ReactDOM from 'react-dom';
import '../../_chunks/dep-5cf1fbb1.js';
import '../../_chunks/dep-f771ed13.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useMessageCssTransition = function useMessageCssTransition(_ref) {
  var contentRef = _ref.contentRef,
    classPrefix = _ref.classPrefix,
    el = _ref.el;
  var timerRef = useRef(null);
  var contentEle = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current;
  var toastAnimationClassPrefix = classPrefix;
  var defaultEvents = {
    onEnter: handleEnter,
    onExited: handleExited
  };
  function handleEnter() {
    clearTimeout(timerRef.current);
    if (contentEle && contentEle.style.display === "none") {
      contentEle.style.display = "block";
    }
  }
  function handleExited() {
    if (contentEle) {
      timerRef.current = setTimeout(function () {
        if (contentEle && contentEle.style.display === "block") {
          contentEle.style.display = "none";
        }
        if (el instanceof Element) {
          var unmountResult = ReactDOM.unmountComponentAtNode(el);
          if (unmountResult) {
            el.parentNode.removeChild(el);
          }
        }
      }, 0);
    }
  }
  return {
    props: _objectSpread(_objectSpread({
      timeout: 200,
      nodeRef: contentRef
    }, defaultEvents), {}, {
      classNames: {
        appear: "".concat(toastAnimationClassPrefix, "-enter ").concat(toastAnimationClassPrefix, "-enter-active"),
        appearActive: "".concat(toastAnimationClassPrefix, "-enter-active"),
        appearDone: "".concat(toastAnimationClassPrefix, "-enter-active ").concat(toastAnimationClassPrefix, "-enter-to"),
        enter: "".concat(toastAnimationClassPrefix, "-enter ").concat(toastAnimationClassPrefix, "-enter-active"),
        enterActive: "".concat(toastAnimationClassPrefix, "-enter-active"),
        enterDone: "".concat(toastAnimationClassPrefix, "-enter-active ").concat(toastAnimationClassPrefix, "-enter-to"),
        exit: "".concat(toastAnimationClassPrefix, "-leave ").concat(toastAnimationClassPrefix, "-leave-active"),
        exitActive: "".concat(toastAnimationClassPrefix, "-leave-active"),
        exitDone: "".concat(toastAnimationClassPrefix, "-leave-active ").concat(toastAnimationClassPrefix, "-leave-to")
      }
    })
  };
};

export { useMessageCssTransition as default };
//# sourceMappingURL=useMessageCssTransition.js.map
